const systems = {
    administrative: "אדמין",
    school: "בית ספר"
}

const systemTypes = {
    school: "school",
    administrative: "administrative"
}

export { systemTypes }

export default systems